import { render, staticRenderFns } from "./GiftSpec.vue?vue&type=template&id=7a4b7a8f&scoped=true&"
import script from "./GiftSpec.vue?vue&type=script&lang=js&"
export * from "./GiftSpec.vue?vue&type=script&lang=js&"
import style0 from "./GiftSpec.vue?vue&type=style&index=0&id=7a4b7a8f&lang=scss&scoped=true&"
import style1 from "./GiftSpec.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4b7a8f",
  null
  
)

export default component.exports